import type { TablerIcon } from "@tabler/icons-react";
import {
  IconBrain,
  IconBuilding,
  IconCloud,
  IconCode,
  IconCpu,
  IconDatabase,
  IconDeviceMobile,
  IconLock,
  IconRocket,
  IconSettings,
  IconShoppingCart,
  IconWorld,
} from "@tabler/icons-react";

export type CorridorTagVisual = {
  Icon: TablerIcon;
  bg: string;
  color: string;
};

const DEFAULT_TAG_VISUAL: CorridorTagVisual = {
  Icon: IconCpu,
  bg: "#DBEAFE",
  color: "#1D4ED8",
};

const TAG_VISUALS: Array<{ match: RegExp; visual: CorridorTagVisual }> = [
  { match: /\b(saas|cloud|paas|iaas)\b/i, visual: { Icon: IconCloud, bg: "#DBEAFE", color: "#1D4ED8" } },
  { match: /\b(ai|ml|a\.?i\.?\/?m\.?l\.?|machine\s*learning|genai|llm)\b/i, visual: { Icon: IconBrain, bg: "#EDE9FE", color: "#6D28D9" } },
  { match: /\b(it\s*services?|software|dev(elopment)?|engineering|coding)\b/i, visual: { Icon: IconCode, bg: "#D1FAE5", color: "#047857" } },
  { match: /\b(fintech|finance|banking|payments?)\b/i, visual: { Icon: IconBuilding, bg: "#E0E7FF", color: "#3730A3" } },
  { match: /\b(cyber|security|secure)\b/i, visual: { Icon: IconLock, bg: "#FEE2E2", color: "#B91C1C" } },
  { match: /\b(data|analytics|bi|warehouse)\b/i, visual: { Icon: IconDatabase, bg: "#CFFAFE", color: "#0E7490" } },
  { match: /\b(mobile|app|apps|android|ios)\b/i, visual: { Icon: IconDeviceMobile, bg: "#FFEDD5", color: "#C2410C" } },
  { match: /\b(ecommerce|e-commerce|retail|marketplace)\b/i, visual: { Icon: IconShoppingCart, bg: "#FCE7F3", color: "#BE185D" } },
  { match: /\b(startup|scale-?up|venture)\b/i, visual: { Icon: IconRocket, bg: "#FEF3C7", color: "#A16207" } },
  { match: /\b(iot|hardware|embedded|electronics)\b/i, visual: { Icon: IconSettings, bg: "#F1F5F9", color: "#334155" } },
  { match: /\b(export|trade|global|international)\b/i, visual: { Icon: IconWorld, bg: "#E0F2FE", color: "#0369A1" } },
];

/** Map free-text expertise tags to colored icon pills for corridor cards. */
export function getCorridorExpertiseTagVisual(tag: string): CorridorTagVisual {
  const normalized = tag.trim();
  if (!normalized) return DEFAULT_TAG_VISUAL;
  for (const entry of TAG_VISUALS) {
    if (entry.match.test(normalized)) return entry.visual;
  }
  return DEFAULT_TAG_VISUAL;
}
